import { api } from '../api/api';
export function getExistingProblemsAction() {
  return function (dispacth) {
    api.get('problem').then((response) => {
      dispacth({ type: 'GET_EXISTING_PROBLEMS_SUCCESS', existingProblems: response.problems });
    });
  };
}
